import { env } from "../env";

export const domain = env.REACT_APP_API_URL;

export const ENDPOINT = {
  POS_USER_BUSINESS_GROUP_PUBLIC: "pos/user-business-group",
  POS: "pos/{businessSlug}",
  POS_BRANCH: "pos/{businessSlug}/branch-pos",
  POS_BRANCH_INFO: "pos/{businessSlug}/branch-info",
  POS_BRANCH_KITCHEN: "pos/{businessSlug}/branch-kitchen",
  POS_BRANCH_PRODUCT: "pos/{businessSlug}/branch-product",
  POS_BUSINESS: "pos/{businessSlug}/business",
  POS_CASH_LOG: "pos/{businessSlug}/pos-cash-log",
  POS_HOLD_ORDER: "pos/{businessSlug}/hold-order",
  USER_BUSINESS_GROUP: "pos/{businessSlug}/user-business-group",

  BLANK: "",
  MEMBERGROUP: "bo/member-group",

  BRANCH: "bo/branch",
  BUSINESS: "bo/business",
  BUSINESS_AUTH: "bo/business-auth",
  BUSINESS_ROLE: "bo/business-role",
  CODE_SETTING: "bo/code-setting",
  EMPLOYEE_DEPARTMENT: "/bo/employee-department",
  EMPLOYEE_POSITION: "/bo/employee-position",
  PERMISSION: "bo/bo-permission",
  PRODUCT: "bo/product",
  PRODUCT_ANNOTATION: "bo/product-annotation",
  PRODUCT_ANNOTATION_ITEM: "bo/product-annotation-item",
  PRODUCT_ANNOTATION_RELATION: "bo/product-annotation-relation",
  PRODUCT_COUNT_UNIT: "bo/product-count-unit",
  PRODUCT_LOG: "bo/product-log",
  PRODUCT_OPTION_STANDARD: "/bo/product-option",
  PRODUCT_OPTION_STANDARD_ITEM: "/bo/product-option-item",
  PRODUCT_OPTION_STANDARD_RELATION: "/bo/product-option-relation",
  PRODUCT_SALE_UNIT: "/bo/product-sale-unit",
  PRODUCT_SPECIFIC_OPTION_RELATION: "bo/product-specific-option-relation",
  PRODUCT_SPECIFIC_OPTION_RELATION_ITEM:
    "bo/product-specific-option-relation-item",
  BRANCH_BANK: "branch-bank-setting",
  BRANCH_CREDIT: "branch-credit-setting",
  BRANCH_DELIVERY: "branch-delivery-setting",
  BRANCH_EMPLOYEE_ROLE: "branch-employee-role",
  BRANCH_PAYMENT: "branch-payment-setting",
  BRANCH_PRODUCT: "branch-product",
  BRANCH_PRODUCT_LOG: "branch-product-log",
  BRANCH_ROLE: "branch-role",
  KITCHEN: "branch-kitchen",
  PRINTER: "branch-printer",
  PRODUCT_CATEGORY: "product-category",
  PRODUCT_SUB_CATEGORY: "product-sub-category",

  MASTER: {
    ACCOUNT_TYPE: "account-type",
    BANK: "bank",
    CODE_SETTING_DAY: "code-setting-day",
    CODE_SETTING_MONTH: "code-setting-month",
    CODE_SETTING_YEAR: "code-setting-year",
    COUNT_UNIT_TYPE: "count-unit-type",
    COUNTER_SETTING: "counter-setting-master",
    CURRENCY: "currency",
    DISTRICT: "district",
    EMPLOYEE_STATUS: "employee-status",
    EMPLOYEE_TYPE: "employee-type",
    ENTITY: "entity-type",
    GENDER: "gender",
    MARITAL: "marital",
    MILITARY: "military",
    PREFIX_NAME: "prefix-name",
    PROVINCE: "province",
    RELATIONSHIP: "relationship",
    RESTAURANT: "restaurant-type",
    ROUNDING_SETTING: "rounding-setting",
    SALARY_TYPE: "salary-type",
    SHOP_PRODUCT: "shop-product-category",
    SUB_DISTRICT: "sub-district",
    TAX_BRANCH: "tax-branch",
    VAT: "vat-calculation",
    VAT_TYPE: "vat-type",
    PAYMENT_METHOD: "payment-method",
    VOID_REMARK: "void-remark",
  },
};
